import React from 'react';

type DocumentNavContextValue = {
  docId: string;
  step: string;
  tab: string | null;
  getUrl(step: string, tab?: string): string;
};

export const DocumentNavContext = React.createContext<DocumentNavContextValue | null>(null);

export default function useDocumentNav(): DocumentNavContextValue {
  const value = React.useContext(DocumentNavContext);
  if (!value) {
    throw new Error('Rendered out of DocumentNavContext.');
  }

  return value;
}
